import React, { Fragment, useMemo } from 'react';
import { formatMoney } from '@shopify/theme-currency';

export default React.memo(function ReformatMoney(props) {
  const { amount, format } = props;
  const moneyString = useMemo(() => formatMoney(amount, format), [amount, format]);

  if (moneyString.includes(Theme.currency)) {
    return (
      <Fragment>
        <span dangerouslySetInnerHTML={{ __html: moneyString }} />
      </Fragment>
    );
  }

  return <Fragment>{moneyString}</Fragment>;
});